import { resetUser } from "utils/analytics";
import getCSRFToken from "helpers/getCSRFToken";

export default async function switchAccount() {
  try {
    await fetch("/auth/switch_account", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRFToken(),
      },
    });
    resetUser();
    window.location.href = "/";
  } catch (error) {
    // TODO(mock-students): update error message
    alert(
      "An error occurred! Please reach out to support if this problem continues.",
    );
  }
}
